import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  height: calc(100vh - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #ffffff;
  text-align: center;

  @media (max-width: 970px) {
    height: calc(100vh - 76px);
  }
`;

export const HeaderInner = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 2;
`;

export const ContentWrapper = styled.div`
  max-width: 450px;
  .section-header {
    color: #fff;
    line-height: 1.2;
    font-size: 1.2rem;
    font-weight: 100;
  }
`;

export const HeaderTitle = styled.h2`
  &.section-title {
    font-size: 3rem;
    font-weight: 900;
    line-height: normal;
    margin-top: 0px;
    margin-bottom: 10px;
    color: #ffffff;

    @media (max-width: 970px) {
      font-size: 2.35rem;
      padding: 0px 10px;
    }
  }
`;

export const HeaderBody = styled.p`
  line-height: 1.2;
  font-size: 1.2rem;
  font-weight: 100;
  padding: 0px 40px;

  @media (max-width: 970px) {
    padding: 0px 35px;
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

export const ScrollWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  left: 0;
  z-index: 20;
  width: 100%;
  text-align: center;
  letter-spacing: 1px;
  font-size: 12px;
  font-weight: 100;
  cursor: pointer;
`;

export const ScrollText = styled.div``;

export const ScrollButton = styled.div`
  width: 20px;
  height: 8px;
  background: url('/public-assets/images/facility-tour/arrow.svg') no-repeat top
    left;
  background-size: contain;
  margin: 5px auto 0px auto;
`;
